import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Calculo from '../views/Calculo.vue'
import AnaliseMunicipios from '../views/AnaliseMunicipios.vue'
import GeracaoDistribuida from '../views/importar/GeracaoDistribuida.vue'
import AnaliseEstados from '../views/importar/AnaliseEstado.vue'
import Login from '../views/Login.vue'
import AlterarSenha from '../views/auth/AlterarSenha.vue'
import CadastroUsuario from '../views/auth/CadastroUsuario.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
}, {
    path: '/calculo',
    name: 'Calculo',
    component: Calculo
}, {
    path: '/analise-municipios',
    name: 'Análise de municípios',
    component: AnaliseMunicipios
}, {
    path: '/importar-geracao-distribuida',
    name: 'Importar geração distribuida',
    component: GeracaoDistribuida
}, {
    path: '/gerar-analise-estados',
    name: 'Gerar análise estados',
    component: AnaliseEstados
}, {
    path: '/login',
    name: 'Login',
    component: Login
}, {
    path: '/alterar-senha',
    name: 'Alterar Senha',
    component: AlterarSenha
}, {
    path: '/cadastrar-usuario',
    name: 'Cadastrar Usuário',
    component: CadastroUsuario
}]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router